
import React from 'react';
import { Business } from '@/schemas/business'; // Corrected import
import { ScrollArea } from "@/components/ui/scroll-area";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { BusinessItem } from './BusinessItem';

interface BusinessesListProps {
  businesses: Business[];
  onBusinessSelect: (business: Business, event: React.MouseEvent) => void;
  maxHeight?: string;
}

export const BusinessesList: React.FC<BusinessesListProps> = ({ 
  businesses, 
  onBusinessSelect,
  maxHeight = "250px"
}) => {
  if (businesses.length === 0) {
    return (
      <div className="py-2 px-3 text-sm text-gray-500">
        No businesses found
      </div>
    );
  }
  
  return (
    <ScrollArea className={`h-[${maxHeight}]`}>
      {businesses.map(business => (
        <DropdownMenuItem 
          key={business.id} 
          className="p-0 cursor-pointer"
        >
          <BusinessItem 
            business={business} 
            onClick={onBusinessSelect}
            showLogo={!!business.logoUrl}
          />
        </DropdownMenuItem>
      ))}
    </ScrollArea>
  );
};
